import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    standalone: false
})
export class SupportComponent implements OnInit {
  showSupport: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  arrowClick(elem?: HTMLElement) {
    this.showSupport = !this.showSupport;
    if (elem) {
      if (this.showSupport)
        elem.className = '_wf-ss-dropdownicon-up';
      else elem.className = '_wf-ss-dropdownicon';
    }
  }

  onNavigate() {
    window.open("https://supportdesk.karexpert.com", "_blank");
  }
}
